import { HttpResponse, delay, http } from 'msw';

import {
  setCustomHandlerLoginStatus,
  setCustomHandlerMembership,
  setCustomHandlerRegisterPlatformStatus,
} from './utils';
import { MOCK_DELAY } from './utils/constants';

export const getCustomPlatformLogoutUserMockHandler = () => {
  return http.delete('*/user/login', async () => {
    await delay(MOCK_DELAY);

    setCustomHandlerLoginStatus(false);
    setCustomHandlerMembership(null);
    setCustomHandlerRegisterPlatformStatus(false);

    return new HttpResponse(null, {
      status: 204,
    });
  });
};
